// Shared wording for the market-coverage footer rendered on SEO pages.

import { translate } from "./i18n";
import { DEFAULT_LOCALE, type Locale } from "./locale";

export const DATA_PERIOD = "2024–2026";
export const COVERAGE_AREA = "Marrakech Medina";

export function methodologyLine(
  count: number,
  locale: Locale = DEFAULT_LOCALE,
): string {
  return translate(locale, "seo_chrome.based_on_listings", {
    count,
    area: COVERAGE_AREA,
    period: DATA_PERIOD,
  });
}
